import { render, staticRenderFns } from "./AddCustomerSupport.vue?vue&type=template&id=4fc8fab4"
import script from "./AddCustomerSupport.vue?vue&type=script&lang=js"
export * from "./AddCustomerSupport.vue?vue&type=script&lang=js"
import style0 from "./AddCustomerSupport.vue?vue&type=style&index=0&id=4fc8fab4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports